var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bec3e1",
    d: "M1.146 10L6 5 1.146 0 0 1.18 3.728 5 0 8.84z"
  })));
}
export default __webpack_public_path__ + "static/svg/chevron-right.svg";
export { SvgChevronRight as ReactComponent };